import { useState } from "react";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { validateFields, commonOnChange, commonOnSelect, formatDate } from "../../../utils";
import { appApis, dropdownDefaultList } from "../../../constants";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { MdOutlineCurrencyRupee } from "react-icons/md";

const AddPayment = ({ show, hideModal, extraDetails, getInstData }) => {
    const [details, setDetails] = useState({
        amount: "",
        paymentType: "",
        referance: "",
        invoiceDate: new Date(),
        amountErr: "",
        paymentTypeErr: "",
        referanceErr: ""
    });

    const { amount, paymentType, invoiceDate, referance, amountErr, paymentTypeErr, referanceErr } = details;
    const { request: submitRequest, loading } = useApiRequest();

    const onChangeHandler = (event) => commonOnChange(event, setDetails);
    const onSelectHandler = (event) => commonOnSelect(event, setDetails);

    const submit = () => {
        validateFields(
            {
                amountErr: [amount, "number"],
                paymentTypeErr: [paymentType, "text"],
                referanceErr: [referance, "text"]
            },
            setDetails,
            () => {
                submitRequest({
                    method: "POST",
                    url: appApis.vehicleLogPayment,
                    body: {
                        "invoiceId": extraDetails?.invoiceid || null,
                        "companyId": extraDetails?.companyId || null,
                        "paymentDate": formatDate(invoiceDate ?? ""),
                        "amountPaid": parseInt(amount) || 0,
                        "paymentMode": paymentType,
                        "remark": referance
                    },
                    onSuccess: () => {
                        getInstData();
                        setTimeout(hideModal, 1000);
                    }
                })
            }
        )
    }

    return <ModalElement size="lg" show={show} title={"Record Payment"} onHide={hideModal}>
        <div className="text-start">
            <div className="company-details mb-3">
                {extraDetails?.companyname ? <div className="d-flex justify-content-between align-items-center me-2 mb-3">
                    <h5 className="mb-3">Company Details</h5>
                    <div className="text-end">
                        <div className="company-name fw-bold">{extraDetails?.companyname ?? ""}</div>
                        <div className="total-amount text-muted">Total: ₹{extraDetails?.totalamount ?? 0}</div>
                    </div>
                </div> : null}
                <div className="row">
                    <div className="col-lg-6 mb-2">
                        <InputElement
                            label={"Amount"}
                            placeholder={"Enter Amount"}
                            name={"amount"}
                            value={amount}
                            error={amountErr}
                            icon={<MdOutlineCurrencyRupee size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className={`col-lg-6 mb-2`}>
                        <InputElement
                            type="date"
                            label={"Payment Date"}
                            placeholder={"Enter Invoice Date"}
                            name={"invoiceDate"}
                            value={invoiceDate}
                            error={false}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <SearchableDropdown
                            label={"Payment Method"}
                            placeholder={"Select Payment Method"}
                            value={paymentType}
                            error={paymentTypeErr}
                            options={dropdownDefaultList.paymentMethod}
                            onSelect={(value) => onSelectHandler({ target: { name: "paymentType", value } })}
                        />
                    </div>
                    <div className="col-md-6 mb-2">
                        <InputElement
                            label={"Remark"}
                            placeholder={"Transaction Id, Cheque No, etc."}
                            name={"referance"}
                            value={referance}
                            error={referanceErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div>
            <div className="submit-btn text-center mb-3">
                <ButtonElement text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" loading={loading} />
            </div>
        </div>
    </ModalElement>
}

export default AddPayment;